import { Params } from "next/dist/server/request/params";
import { useParams } from "next/navigation";

export type ISelectedSportResultParams = {
    sportSlug: string;
    categoryId: number;
    gameId: number;
};

function getDefaultSportResultsParamsFromUrl(params: Params): ISelectedSportResultParams {
    const [resultsGameRoutesSport, resultsGameRoutesCategoryId, resultsGameRoutesGameId] =
        params.resultsGameRoutes ?? [];
    const sport = params.sport || resultsGameRoutesSport;
    const categoryId = params.categoryId || resultsGameRoutesCategoryId;
    const gameId = params.gameId || resultsGameRoutesGameId;

    return {
        sportSlug: sport as string,
        categoryId: parseInt(categoryId as string),
        gameId: parseInt(gameId as string),
    };
}

export const useDefaultSportResultParamsFromUrl = (): ISelectedSportResultParams => {
    const params = useParams();
    const defaultUrlParams = getDefaultSportResultsParamsFromUrl(params);

    return defaultUrlParams;
};

export const useSelectedSportResultsGameId = (): number | null => {
    const params = useParams();
    const { gameId: routeGameId } = getDefaultSportResultsParamsFromUrl(params);

    return routeGameId || null;
};
